/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Donotsendinvoice3Inputs */

const en__field_donotsendinvoice3 = /** @type {(inputs: _Field_Donotsendinvoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`should not receive invoice`)
};

const de__field_donotsendinvoice3 = /** @type {(inputs: _Field_Donotsendinvoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erhält keine Rechnung`)
};

/**
* | output |
* | --- |
* | "should not receive invoice" |
*
* @param {_Field_Donotsendinvoice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_donotsendinvoice3 = /** @type {((inputs?: _Field_Donotsendinvoice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Donotsendinvoice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_donotsendinvoice3(inputs)
	return de__field_donotsendinvoice3(inputs)
});
export { _field_donotsendinvoice3 as "_field_doNotSendInvoice" }